export type CountryOption = {
  code: string;
  name: string;
  flag: string;
  currency: string;
  currencySymbol: string;
  locale: string;
};

export const COUNTRIES: CountryOption[] = [
  { code: "BR", name: "Brasil", flag: "🇧🇷", currency: "BRL", currencySymbol: "R$", locale: "pt-BR" },
  { code: "PT", name: "Portugal", flag: "🇵🇹", currency: "EUR", currencySymbol: "€", locale: "pt-PT" },
  { code: "US", name: "Estados Unidos", flag: "🇺🇸", currency: "USD", currencySymbol: "$", locale: "en-US" },
  { code: "AR", name: "Argentina", flag: "🇦🇷", currency: "ARS", currencySymbol: "$", locale: "es-AR" },
  { code: "PY", name: "Paraguai", flag: "🇵🇾", currency: "PYG", currencySymbol: "₲", locale: "es-PY" },
  { code: "AO", name: "Angola", flag: "🇦🇴", currency: "AOA", currencySymbol: "Kz", locale: "pt-AO" },
];

export const getCountry = (code: string): CountryOption =>
  COUNTRIES.find((c) => c.code === code) ?? COUNTRIES[0];

export const getCountryByCurrency = (currency: string): CountryOption =>
  COUNTRIES.find((c) => c.currency === currency) ?? COUNTRIES[0];